import { Pipe, PipeTransform } from '@angular/core';

import { PhoneNumberUtil } from '../../utils/phone-number.util';

@Pipe({
    name: 'multiplePhoneNumber',
    standalone: true,
})
export class MultiplePhoneNumberPipe implements PipeTransform {
    /**
     * Transforms "something with 0XXXXXXXXX or 33XXXXXXXXX" to "something with 06 XX XX XX XX"
     *      Not Transforms "something with string"
     * @param {string | string[]} data Text to be filtered
     * @returns {string | string[]} Filtered text
     */
    public transform(data: string[] | null | undefined): string[] | null | undefined {
        if (!data) {
            return data;
        }
        return data.map((item) => PhoneNumberUtil.getFormattedPhone(item));
    }
}
